const dateFormatISO = /^(\d{4})-([0]\d|1[0-2])-([0-2]\d|3[01])$/; // YYYY-MM-DD
const dateFormatUS = /^([0]\d|1[0-2])-([0-2]\d|3[01])-(\d{4})$/; // MM-DD-YYYY
const dateFormatOther = /^([0-2]\d|3[01])-([0]\d|1[0-2])-(\d{4}$)/; // DD-MM-YYYY
const millisecondInSeconds = 1000;
const millisecondInMinute = millisecondInSeconds * 60;
const millisecondInHour = millisecondInMinute * 60;
const millisecondInDay = millisecondInHour * 24;
const millisecondInWeek = millisecondInDay * 7;
// TODO: review / with decision to change to NgCore version [future release]
// NOTE: need to scan as mods made that differ from NgCore
/**
 * @deprecate - Use ng-core library instead
 */
export class DatesUtil {
  public static getToday(): Date {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  }

  public static convertToString(date: Date | null) {
    if (date != null) {
      return date.toLocaleDateString();
    } else {
      return '';
    }
  }
  public static convertToDate(date: string | null): Date | null {
    if (!date) {
      return null;
    }
    let years: number | undefined = undefined;
    let months: number | undefined = undefined;
    let days: number | undefined = undefined;

    //Remove the time component if it exists
    date = date?.split('T')[0];

    // ISO
    if (dateFormatISO.test(date)) {
      [years, months, days] = date.split(/\-/).map(Number);
    }
    // US
    if (dateFormatUS.test(date)) {
      [months, days, years] = date.split(/\-/).map(Number);
    }
    // other
    if (dateFormatOther.test(date)) {
      [days, months, years] = date.split(/\-/).map(Number);
    }

    if (years == undefined || months == undefined || days == undefined) {
      return null;
    }
    const converteddate = new Date(years, months - 1, days);

    if (
      converteddate.getFullYear() === years &&
      converteddate.getDate() === days &&
      converteddate.getMonth() === months - 1
    ) {
      return converteddate;
    }

    return null;
  }
  public static isValidDate(date: Date | string): boolean {
    if (!date) {
      return false;
    }
    let newDate: Date | null;
    if (typeof date === 'string') {
      newDate = this.convertToDate(date);
      if (!newDate) {
        return false;
      }
    } else {
      newDate = date;
    }
    return !isNaN(newDate.getTime());
  }
  public static isCompleteDateValue(dateValue: string | null | undefined): boolean {
    if (!dateValue) return true;
    return dateFormatISO.test(dateValue) && this.isValidDate(dateValue);
  }
  public static isEqual(startDate: Date, endDate: Date): boolean {
    return startDate.getTime() === endDate.getTime();
  }
  public static isWithinRange(
    date: Date,
    startDate: Date,
    endDate: Date
  ): boolean {
    return (
      date.getTime() >= startDate.getTime() &&
      date.getTime() <= endDate.getTime()
    );
  }
  // past and future
  public static isPast(date: Date): boolean {
    var today = this.getToday();
    return date.getTime() < today.getTime();
  }
  public static isFuture(date: Date): boolean {
    var today = this.getToday();
    return date.getTime() > today.getTime();
  }
  // before and after
  public static isBefore(date: Date, dateToCompare: Date): boolean {
    return date.getTime() < dateToCompare.getTime();
  }
  public static isAfter(date: Date, dateToCompare: Date): boolean {
    return date.getTime() > dateToCompare.getTime();
  }
  // age
  public static getAge(
    birthDate: Date,
    fromDate: Date = this.getToday()
  ): number {
    const age = fromDate.getFullYear() - birthDate.getFullYear();
    if (
      fromDate.getMonth() < birthDate.getMonth() ||
      (fromDate.getMonth() === birthDate.getMonth() &&
        fromDate.getDate() < birthDate.getDate())
    ) {
      return age - 1;
    }
    return age;
  }
  // seconds
  public static addSeconds(date: Date, seconds: number): Date {
    date.setSeconds(date.getSeconds() + seconds);
    return date;
  }
  public static differenceInSeconds(
    startDate: Date,
    endDate: Date = this.getToday()
  ): number {
    const diff =
      Math.abs(startDate.getTime() - endDate.getTime()) / millisecondInSeconds;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
  }
  // minutes
  public static addMinutes(date: Date, minutes: number): Date {
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }
  public static differenceInMinutes(
    startDate: Date,
    endDate: Date = this.getToday()
  ): number {
    const diff =
      Math.abs(startDate.getTime() - endDate.getTime()) / millisecondInMinute;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
  }
  // hours
  public static addHours(date: Date, hours: number): Date {
    date.setHours(date.getHours() + hours);
    return date;
  }
  public static differenceInHours(
    startDate: Date,
    endDate: Date = this.getToday()
  ): number {
    const diff =
      Math.abs(startDate.getTime() - endDate.getTime()) / millisecondInHour;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
  }
  // days
  public static addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }
  public static differenceInDays(
    startDate: Date,
    endDate: Date = this.getToday()
  ): number {
    const diff =
      Math.abs(startDate.getTime() - endDate.getTime()) / millisecondInDay;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
  }

  // Performs the same function as above but returns a relative number instead of an absolute number.
  // A negative result means days past, a positive result is days until.
  public static offsetInDays(
    startDate: Date,
    endDate: Date = this.getToday()
  ): number {
    const diff = (startDate.getTime() - endDate.getTime()) / millisecondInDay;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
  }
  public static daysInMonth(date: Date): number {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }
  public static daysInYear(date: Date): number {
    return this.isLeapYear(date) ? 366 : 365;
  }
  // weeks
  public static addWeeks(date: Date, weeks: number): Date {
    const days = weeks * 7;
    date.setDate(date.getDate() + days);
    return date;
  }
  public static differenceInWeeks(
    startDate: Date,
    endDate: Date = this.getToday()
  ): number {
    const diff =
      Math.abs(startDate.getTime() - endDate.getTime()) / millisecondInWeek;
    return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
  }
  // months
  public static addMonths(date: Date, months: number): Date {
    date.setMonth(date.getMonth() + months);
    return date;
  }
  // years
  public static addYears(date: Date, years: number): Date {
    date.setFullYear(date.getFullYear() + years);
    return date;
  }
  public static isLeapYear(date: Date): boolean {
    const year = date.getFullYear();
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  public static getDateString(date: string | null | undefined): string {
    return (date ?? '').split('T')[0];
  }

  // Function to extract the local date in the format YYYY-MM-DD
  // The offset which is the diffence between localtime and utcTime in minutes and for NZ and AU this will be a negative value, hence subtracting this value from localTime will shift the localtime so that the call to toISOString() will return the formatted localTime.
  public static localDateTime() {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    const localDate = new Date(today.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split('.')[0];
  }

  public static extractFormattedLocalDate() {
    return DatesUtil.localDateTime().split('T')[0];
  }

  /**
   * Convert a local date string (YYYY-MM-DD) to UTC datetime string (start of day)
   * Format: "YYYY-MM-DD HH:mm:ss.SSS" (without T and Z)
   * This ensures API filters match what users see on UI (which displays local time)
   * Example: User in AEDT selects 2025-01-10 → returns "2025-01-09 13:00:00.000"
   */
  public static toUtcStartOfDay(localDateString: string | null | undefined): string | null {
    if (!localDateString) return null;
    const localDate = this.convertToDate(localDateString);
    if (!localDate) return null;
    return localDate.toISOString().replace('T', ' ').replace('Z', '');
  }

  /**
   * Convert a local date string (YYYY-MM-DD) to UTC datetime string (end of day)
   * Format: "YYYY-MM-DD HH:mm:ss.SSS" (without T and Z)
   * This ensures the "to" date includes all records from that local day
   * Example: User in AEDT selects 2025-01-10 → returns "2025-01-10 12:59:59.999"
   */
  public static toUtcEndOfDay(localDateString: string | null | undefined): string | null {
    if (!localDateString) return null;
    const localDate = this.convertToDate(localDateString);
    if (!localDate) return null;
    localDate.setHours(23, 59, 59, 999);
    return localDate.toISOString().replace('T', ' ').replace('Z', '');
  }
}
